import { cn } from '@/lib/utils';
import { LoaderCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface Props {
  className?: string;
  withText?: boolean;
}

export const Loader = ({ className, withText = true }: Props) => {
  const { t } = useTranslation();

  const loaderImage = (
    <LoaderCircle
      aria-label={ t('ariaLabels.loading') }
      className={ cn('animate-spin size-10 text-text-brand', className) }
    />
  );

  if (!withText) return loaderImage;

  return (
    <div className="flex flex-col items-center gap-space-2xs">
      { loaderImage }
      <p>{ t('loading') }</p>
    </div>
  );
};
